import { axiosRetry } from '@/plugins/axios';

const base = '/gift-cards';

/**
 * API Calls
 */
export function checkGiftCardBalance(params) {
    return axiosRetry.get(`${base}/balance`, { params });
}

export function redeemGiftCard(payload) {
    return axiosRetry.post(`${base}/redeem`, payload);
}

export function isGiftCardEnabled(accountId, venueId) {
    return axiosRetry.get(
        `toggle/account/${accountId}/venue/${venueId}/status`
    );
}

/**
 * Helper Functions
 */
export function calculateGiftCardPaymentAmount(giftCardBalance, cartTotal) {
    if (giftCardBalance <= 0) {
        return 0;
    }

    if (cartTotal <= giftCardBalance) {
        return cartTotal;
    }

    return giftCardBalance;
}

export function calculateRemainingCartTotal(cartTotal, giftCardAmount) {
    const remaining = cartTotal - giftCardAmount;
    return remaining < 0 ? 0 : remaining;
}

export function formatProviderName(provider) {
    return provider === 'giftpro' ? 'BAO' : provider;
}

export function validateGiftCardCode(code) {
    if (!code || code.trim() === '') {
        return 'Please enter a gift card code';
    }

    return null;
}
